export default {"src":"/_next/static/media/conflictsManagement.d2211ba9.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};